import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * When set to `true` on a request's {@link HttpContext}, {@link LoadingInterceptor}
 * will not show/hide the global NgxSpinner for that request (use local UI spinners instead).
 */
export const SKIP_GLOBAL_LOADING = new HttpContextToken<boolean>(() => false);

/** Merge skip-global-loading into an existing or new {@link HttpContext}. */
export function withSkipGlobalLoading(existing?: HttpContext): HttpContext {
  return (existing ?? new HttpContext()).set(SKIP_GLOBAL_LOADING, true);
}
